import { toast } from 'sonner';

/**
 * Toast shown when a scenario, suite, or suite run is hidden in demo mode,
 * pointing users to where they can review and unhide. Uses a stable id so a
 * burst of hides updates a single toast instead of stacking many.
 */
export function notifyDemoHidden(): void {
  toast('Hidden from the demo view', {
    id: 'demo-hide-hint',
    description: 'Manage or unhide anything in Settings → Demo Mode.',
  });
}
